var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeSaude(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.115,
    height: 50,
    viewBox: "0 0 93.115 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3001 4838.06)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2971.106 -4838.06)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.422,358.1l-6.124,6.129-16.913-16.913-2.474-2.474-2.9-2.9a12.113,12.113,0,0,1-.2-17.105,11.751,11.751,0,0,1,8.376-3.432,12.289,12.289,0,0,1,8.733,3.624l.571.571,2.383-2.561-.483-.479a15.741,15.741,0,0,0-11.2-4.648,15.217,15.217,0,0,0-10.846,4.452,15.613,15.613,0,0,0,.192,22.053l3.092,3.088,2.531,2.531,16.412,16.417.161.161a4.438,4.438,0,0,0,2.544,1.3,3.484,3.484,0,0,0,2.461-1.185l.279-.274,5.636-5.641A17.151,17.151,0,0,1,435.422,358.1Z",
    transform: "translate(-399.883 -317.905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.161,322.357a15.224,15.224,0,0,0-10.846-4.452,15.741,15.741,0,0,0-11.2,4.648l-2.422,2.418-.436.483-4.186,4.282a1.748,1.748,0,1,0,2.5,2.444l5.811-5.941.031-.043,1.172-1.172a12.282,12.282,0,0,1,8.733-3.624,11.706,11.706,0,0,1,11.8,11.351,16.8,16.8,0,0,1,3.454,1.686A15.308,15.308,0,0,0,435.161,322.357Z",
    transform: "translate(-380.796 -317.905)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.376 17.523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.15,323.562a7.042,7.042,0,0,0-4.469,6.525,1.5,1.5,0,1,0,3,0,4.026,4.026,0,0,1,2.557-3.729,1.5,1.5,0,0,0-1.085-2.8Z",
    transform: "translate(-403.378 -316.789)",
    fill: "#da3832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.713,349.853l-3.933-5.092a13.266,13.266,0,1,0-2.805,2.091l3.973,5.14a1.75,1.75,0,0,0,1.385.68,1.722,1.722,0,0,0,1.067-.366A1.744,1.744,0,0,0,434.713,349.853Zm-22.985-14.622a9.8,9.8,0,1,1,9.8,9.8A9.81,9.81,0,0,1,411.727,335.231Z",
    transform: "translate(-408.234 -321.928)",
    fill: "#da3832"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2984.054 -4808.276)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 10.903,
    transform: "translate(5.452 0)",
    fill: "none",
    stroke: "#da3832",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 10.903,
    transform: "translate(10.903 5.452) rotate(90)",
    fill: "none",
    stroke: "#da3832",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2999.5 -4828.265)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 10.903,
    transform: "translate(5.452 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 10.903,
    transform: "translate(10.903 5.452) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeSaude);
export default __webpack_public_path__ + "static/media/icone-saude.fdeb376e024f04fc2c2336556d62bd20.svg";
export { ForwardRef as ReactComponent };